import { useContext, useMemo } from 'react';
import FrameworkProvider from '../cnr/contexts/FrameworkContent';
import { ParentContext } from "../cnr/contexts/ParentContext";
import { g_cns } from '../common/cns';
import { gEnums } from "../enums/globalEnums";
import { _animateTypes } from '../motions/AnimateComponent';
import MotionComponent from '../motions/MotionComponent';
import CreateFeedEvent from '../viewSettings/events/CreateFeedEvent';
import PageFramework from "./PageFramework";

/**
 * 
 * @returns PageFramework within a FrameworkProvider
 */
const PageDevice = () => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state, appSettings_state, appUser_state, paps_state, transition_state } = states

  const { transitions, isNewRoute } = transition_state ?? {}
  const transition = transitions ? transitions[_animateTypes.route] : null
  const { showTransition } = transition ?? {}

  // authContext 
  const { appUser } = appUser_state ?? {}
  const { appUserAccess } = appUser ?? {}

  // appSettings_state 
  let { desktopMode } = appSettings_state ?? {}

  // paps_state 
  const { view, pathViews } = paps_state ?? {}
  const isMobileDevice = _.get(app_state, 'currentEnvironment.platform.isMobileDevice', false)
  const ima = isMobileDevice ? 'm' : 'd'

  // Memoize framework content function
  const frameworkContent = useMemo(() => {
    return (mediaDeviceType) => {
      const mp = { addSettings: false, mediaDeviceType, hasSettings: true, isMobileDevice };
      return (
        <FrameworkProvider {...mp}>
          <PageFramework />
        </FrameworkProvider>
      );
    };
  }, [isMobileDevice]);

  // Memoize className computation
  // const rcn = useMemo(() => {
  //   let className = `${g_cns.page_area_content} au`;
  //   className += desktopMode ? ' dt-on' : ' dt-off';
  //   className += ` ima-${ima}`;
  //   if (appUserAccess) {
  //     className += ` apl-${appUserAccess.accessLevel}`;
  //   }
  //   return className;
  // }, [desktopMode, ima, appUserAccess]);

  // Memoize layout rendering
  const mobileOrDesktop = useMemo(() => {
    return (
      frameworkContent(isMobileDevice ? gEnums.mediaDeviceTypes.mobile : gEnums.mediaDeviceTypes.desktop)
    );
  }, [pathViews, paps_state.view, isMobileDevice]);

  const content = useMemo(() => {
    switch (view) {
      case 'createFeedEvent':
        return <CreateFeedEvent />;
      default:
        return mobileOrDesktop;
    }
  }, [view, mobileOrDesktop, pathViews]);

  return showTransition ? <MotionComponent transition={transition} isNewRoute={isNewRoute}>
    {content}
  </MotionComponent>
    : content
}

export default PageDevice